<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" absolute max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Main Info</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field
              readonly
              v-model="rowToSave.match_weight"
              label="Match weight"
            />
            <v-text-field
              readonly
              v-model="rowToSave.orig_code"
              label="Orig code"
            />
            <v-text-field
              readonly
              v-model="rowToSave.orig_external_code"
              label="Orig External code"
            />
            <v-text-field
              readonly
              v-model="rowToSave.orig_name"
              label="Orig name"
            />
            <v-text-field
              readonly
              v-model="rowToSave.orig_order"
              label="Orig order"
            />
            <v-text-field
              readonly
              v-model="rowToSave.entry_variation_name"
              label="Entry variation name"
            />
            <v-text-field
              readonly
              v-model="rowToSave.variation"
              label="Variation"
            />

            <v-text-field
              readonly
              v-model="rowToSave.package_type"
              label="Package type"
            />
            <v-text-field
              readonly
              v-model="rowToSave.rhapsody_code"
              label="Rhapsody code"
            />
            <v-text-field
              readonly
              v-model="rowToSave.rhapsody_code_override"
              label="Rhapsody code override"
            />
            <v-text-field
              readonly
              v-model="rowToSave.rhapsody_name"
              label="Rhapsody name"
            />
            <v-text-field
              readonly
              v-model="rowToSave.pim_package_info"
              label="Pim package info"
            />
            <v-text-field readonly v-model="rowToSave.vendor" label="Vendor" />
            <v-text-field
              readonly
              v-model="rowToSave.vendor_code"
              label="Vendor code"
            />
            <v-text-field readonly v-model="rowToSave.markup" label="markup" />
            <v-text-field
              readonly
              v-model="rowToSave.markup_type"
              label="Markup type"
            />
            <v-text-field readonly v-model="rowToSave.cost" label="Cost" />
            <v-text-field
              readonly
              v-model="rowToSave.custom_primary_category"
              label="Primary category"
            />
            <v-text-field
              readonly
              v-model="rowToSave.custom_secondary_category"
              label="Secondary category"
            />
            <v-text-field
              readonly
              v-model="rowToSave.custom_tertiary_category"
              label="Tertiary category"
            />

            <v-textarea
              readonly
              label="Props structure"
              auto-grow
              v-model="rowToSave.propsStructure"
            />
            <v-textarea
              readonly
              label="Variation structure"
              auto-grow
              v-model="rowToSave.variationStructure"
            />
            <v-textarea
              readonly
              label="Property object"
              auto-grow
              v-model="rowToSave.property_object"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'TaskCreationDialog',
  props: {
    priceInfo: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    row: {
      priceInfo: {}
    },
    rowToSave: {},
    dialog: false,
    loading: false,
    disabled: false
  }),

  methods: {
    open(row, disabled) {
      this.disabled = disabled;
      this.row = row;
      this.rowToSave = {
        ...this.row,
        variationStructure: JSON.stringify(
          this.row.variationStructure,
          undefined,
          4
        ),
        propsStructure: JSON.stringify(this.row.propsStructure, undefined, 4),
        property_object: JSON.stringify(this.row.property_object, undefined, 4)
      };

      this.dialog = true;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
